import React from 'react';

import BenchlingConfig from 'BenchlingConfig';
import ConfigureReviewCriteriaSection from 'notebook/reviews/ConfigureReviewCriteriaSection';
import Col from 'ui-library/bs/Col';
import Row from 'ui-library/bs/Row';

interface NoReviewInProgressProps {
  linkedItemId: string;
  writable: boolean;
}

export default function NoReviewInProgress({linkedItemId, writable}: NoReviewInProgressProps): JSX.Element {
  return (
    <div>
      <Row>
        <Col sm={12}>
          <div className="u-faded">
            Entry is currently in progress - there is no review yet.
            {writable && ' Click "Send for Review" to start the review process...'}
          </div>
        </Col>
      </Row>
      {BenchlingConfig.ENABLE_ELN_REVIEW_CRITERIA && (
        <ConfigureReviewCriteriaSection linkedItemId={linkedItemId} writable={writable} />
      )}
    </div>
  );
}
